"use strict";

exports.__esModule = true;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Represents a 2d point
 */


var Point = function () {
  /** @public */
  function Point() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    (0, _classCallCheck3.default)(this, Point);
    /**
     * The x-coordinate of the point
     * @type {number}
     */

    this.x = x;
    /**
     * The y-coordinate of the point
     * @type {number}
     */

    this.y = y;
  }
  /**
   * Returns a copy of this point
   * @return {Point}
   */


  Point.prototype.copy = function copy() {
    return new Point(this.x, this.y);
  };

  Point.prototype.transform = function transform(m0, m1, m2, m3, m4, m5) {
    var x = m0 * this.x + m2 * this.y + m4;
    var y = m1 * this.x + m3 * this.y + m5;
    return new Point(x, y);
  };

  return Point;
}();

exports.default = Point;